import { DiscountRequestData, ILocation, IUser } from 'interfaces';

export enum NotificationType {
  ASSIGNED_TO_YOU = 'ASSIGNED_TO_YOU',
  ASSIGNED_TO_ANOTHER = 'ASSIGNED_TO_ANOTHER',
  STATUS_CHANGED = 'STATUS_CHANGED',
  NEW_DEMAND = 'NEW_DEMAND',
}

export type DiscountRequestNotification = Omit<
  DiscountRequestData,
  'country' | 'city' | 'location' | 'login'
> & {
  demandId: number;
  locationDto: ILocation;
  received: boolean;
  notificationType: NotificationType;
  hrComment?: string;
  notificationTime: string;
  user?: IUser;
};

export type DiscountRequestNotificationParams = {
  page?: number;
  size?: number;
  sort?:
    | 'ID'
    | 'FIRSTNAME'
    | 'LASTNAME'
    | 'COMPANY_NAME'
    | 'CREATED_DATE'
    | 'RECEIVED'
    | 'NOTIFICATION_TIME';
  direction?: 'ASC' | 'DESC';
  typeFilter?: NotificationType[];
};

export type DiscountRequestNotificationCounts = {
  all: number;
  newDemands: number;
  assignedToAnother: number;
  assignedToYou: number;
  statusChanged: number;
};

export enum EDiscountDemandTypes {
  CREATED = 'DISCOUNT_DEMAND_CREATED',
  STATUS_CHANGED = 'DISCOUNT_DEMAND_STATUS_CHANGED',
  AUTO_ASSIGNED = 'DISCOUNT_DEMAND_AUTO_ASSIGNED',
  ASSIGNED_TO_YOU = 'DISCOUNT_DEMAND_ASSIGNED_TO_YOU',
  ASSIGNED_TO_ANOTHER = 'DISCOUNT_DEMAND_ASSIGNED_TO_ANOTHER',
}

export interface DiscountRequest {
  id: number;
  userId: number;
  message: string;
  discountDemandId: number;
  discountDemandHistoryId: number;
  statusBefore: string;
  statusAfter: string;
  discountDemandEventType: string;
  type: EDiscountDemandTypes;
  timeCreate: string;
  isRead: boolean;
}
